import React from "react";
import PropTypes from "prop-types";
import classes from "./MenuWithIcons.module.css";
import {
  EditLessonInfoIconBlack,
  EditProfileBlackIcon,
  HelpIconBlack,
  logoutIcon,
  SettingsIconBlack,
} from "../../constant/imagePath";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";

export const MenuWithIcons = ({ menuItems, customStyle }) => {
  return (
    <div className={classes.menu} style={customStyle}>
      <ul className={["p-0"].join(" ")}>
        {menuItems?.map((item) => {
          return (
            <li onClick={item?.onClick} key={item?.label}>
              <img src={item?.icon} />{" "}
              <span style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
                {item?.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

MenuWithIcons.propTypes = {
  menuItems: PropTypes.array,
};
MenuWithIcons.defaultProps = {
  menuItems: [
    { icon: HelpIconBlack, label: "Help", onClick: "" },
    { icon: EditProfileBlackIcon, label: "Edit Profile", onClick: "" },
    { icon: EditLessonInfoIconBlack, label: "Edit Lesson Info", onClick: "" },
    { icon: SettingsIconBlack, label: "Settings", onClick: "" },
    { icon: logoutIcon, label: "Log out", onClick: "" },
  ],
};
